import { render, staticRenderFns } from "./ScrollTopButton.vue?vue&type=template&id=c970b036&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollTopButton.vue?vue&type=style&index=0&id=c970b036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c970b036",
  null
  
)

export default component.exports